import { useTranslation } from 'react-i18next';
import { useLocation, Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  path: string;
}

export function Breadcrumbs() {
  const { t } = useTranslation();
  const location = useLocation();

  const getBreadcrumbs = (): BreadcrumbItem[] => {
    const paths = location.pathname.split('/').filter(Boolean);
    const breadcrumbs: BreadcrumbItem[] = [];

    let currentPath = '';
    paths.forEach((path) => {
      currentPath += `/${path}`;

      // Map paths to translation keys
      const labelKey = path === 'dashboard'
        ? 'nav.dashboard'
        : path === 'patients'
        ? 'nav.patients'
        : path === 'appointments'
        ? 'nav.appointments'
        : path === 'treatments'
        ? 'nav.treatments'
        : path === 'invoices'
        ? 'nav.invoices'
        : path === 'settings'
        ? 'nav.settings'
        : path;

      breadcrumbs.push({
        label: t(labelKey),
        path: currentPath,
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm" aria-label="Breadcrumb">
      <Link
        to="/dashboard"
        className="flex items-center text-gray-500 hover:text-brand-primary transition-colors"
        aria-label={t('nav.dashboard')}
      >
        <Home className="h-4 w-4" />
      </Link>

      {breadcrumbs.map((crumb, index) => {
        const isLast = index === breadcrumbs.length - 1;

        return (
          <div key={crumb.path} className="flex items-center">
            <ChevronRight className="h-4 w-4 text-gray-400 mx-1" />
            {isLast ? (
              <span className="text-gray-900 font-medium" aria-current="page">
                {crumb.label}
              </span>
            ) : (
              <Link
                to={crumb.path}
                className="text-gray-500 hover:text-brand-primary transition-colors"
              >
                {crumb.label}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
}
